"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRef = void 0;
var InitBinaryWriteImpulse_1 = require("../graphql/request/input/InitBinaryWriteImpulse");
var CompleteBinaryWriteImpulse_1 = require("../graphql/request/input/CompleteBinaryWriteImpulse");
var BinaryWriteChunkImpulse_1 = require("../graphql/request/input/BinaryWriteChunkImpulse");
var rxjs_1 = require("rxjs");
var ListFilesImpulse_1 = require("../graphql/request/input/ListFilesImpulse");
var RemoveFileImpulse_1 = require("../graphql/request/input/RemoveFileImpulse");
var BinaryReadImpulse_1 = require("../graphql/request/input/BinaryReadImpulse");
var DataRef = /** @class */ (function () {
    function DataRef(uri, client) {
        this.uri = uri;
        this.client = client;
    }
    /**
     * Adds a file to the directory specified by the uri member of this class.
     * If the file already exists at the given uri, it is only overwritten if override is set, else the Observable fails.
     *
     * @param fileName name of the new file to be written
     * @param content binary content of the file to be written
     * @param override flag to decide if existing files should be overwritten
     * @param config optional interface which currently only contains onUploadProgress callback
     */
    DataRef.prototype.add = function (fileName, content, override, config) {
        var _this = this;
        if (override === void 0) { override = false; }
        var upload = DataUpload.create(DataRef.concatUri(this.uri, fileName), content, override, config);
        return rxjs_1.defer(function () { return upload.execute(_this.client); });
    };
    /**
     * Lists all files whose uri has the current uri member as its prefix.
     */
    DataRef.prototype.list = function () {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post(new ListFilesImpulse_1.ListFilesImpulse(_this.uri), '/data/list')
            .catch(function (reason) {
            throw new Error('Listing files at uri ' + _this.uri + ' failed: ' + reason);
        }); });
    };
    DataRef.prototype.removeFileAt = function (uri) {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.post(new RemoveFileImpulse_1.RemoveFileImpulse(uri), '/data/remove')
            .catch(function (reason) {
            throw new Error('Removing file with uri ' + uri + ' failed: ' + reason);
        }); });
    };
    /**
     * Removes a file from the the directory specified by the uri member of this class.
     *
     * @param fileName the name of the file to be removed
     * @returns an Observable<boolean> that is true if the file existed
     */
    DataRef.prototype.removeFile = function (fileName) {
        return this.removeFileAt(DataRef.concatUri(this.uri, fileName));
    };
    /**
     * Removes a file at the uri of this DataRef
     *
     * @returns an Observable<boolean> that is true if the file existed
     */
    DataRef.prototype.remove = function () {
        return this.removeFileAt(this.uri);
    };
    DataRef.prototype.asFile = function () {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.postAndRetrieveBinary(new BinaryReadImpulse_1.BinaryReadImpulse(_this.uri), '/data/source')
            .catch(function (reason) {
            throw new Error('Download of file with uri ' + _this.uri + ' failed: ' + reason);
        }); });
    };
    DataRef.prototype.asStream = function () {
        console.log('asStream');
        throw new Error('Not implemented');
    };
    DataRef.prototype.append = function (dataToAppend) {
        console.log('Append: ' + dataToAppend);
        throw new Error('Not implemented');
    };
    DataRef.concatUri = function (baseUri) {
        var paths = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            paths[_i - 1] = arguments[_i];
        }
        var uri = paths.reduce(function (uri, path) {
            var uriWithTrailingSlash = uri.endsWith('/') ? uri : uri + '/';
            var pathWithoutLeadingSlash = path.startsWith('/') ? path.substr(1) : path;
            return uriWithTrailingSlash + pathWithoutLeadingSlash;
        }, baseUri);
        return uri.endsWith('/') ? uri.substr(0, uri.length - 1) : uri;
    };
    DataRef.prototype.getUri = function () {
        return this.uri;
    };
    return DataRef;
}());
exports.DataRef = DataRef;
var DataUpload = /** @class */ (function () {
    function DataUpload(uri, content, totalNumberOfChunks, override, config) {
        this.uri = uri;
        this.content = content;
        this.totalNumberOfChunks = totalNumberOfChunks;
        this.override = override;
        this.config = config;
    }
    DataUpload.create = function (uri, content, override, config) {
        if (override === void 0) { override = false; }
        var numberOfChunks = Math.ceil(content.size / DataUpload.CHUNK_SIZE);
        return new DataUpload(uri, content, numberOfChunks, override, config);
    };
    DataUpload.prototype.execute = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var initResponse, chunkResponsesIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.post(new InitBinaryWriteImpulse_1.InitBinaryWriteImpulse(this.uri, this.override), '/data/sink/init')];
                    case 1:
                        initResponse = _a.sent();
                        return [4 /*yield*/, this.getChunkRequestsAndSendChunks(initResponse.uploadId, client)];
                    case 2:
                        chunkResponsesIds = _a.sent();
                        return [2 /*return*/, client.post(new CompleteBinaryWriteImpulse_1.CompleteBinaryWriteImpulse(this.uri, initResponse.uploadId, chunkResponsesIds), '/data/sink/complete')
                                .then(function () { return new DataRef(_this.uri, client); }, function (reason) {
                                throw new Error('Upload to uri ' + _this.uri + ' failed: ' + reason.stack);
                            })];
                }
            });
        });
    };
    DataUpload.prototype.getChunkRequestsAndSendChunks = function (uploadId, client) {
        return __awaiter(this, void 0, void 0, function () {
            var chunkResponsesIds, index, chunk, binaryWriteChunkImpulse, data, chunkResponse, progress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chunkResponsesIds = Array();
                        index = 0;
                        _a.label = 1;
                    case 1:
                        if (!(index < this.totalNumberOfChunks)) return [3 /*break*/, 5];
                        chunk = this.content.slice(DataUpload.CHUNK_SIZE * index, Math.min(DataUpload.CHUNK_SIZE * (index + 1), this.content.size));
                        binaryWriteChunkImpulse = new BinaryWriteChunkImpulse_1.BinaryWriteChunkImpulse(this.uri, uploadId, index + 1, chunk.size, chunk);
                        return [4 /*yield*/, binaryWriteChunkImpulse.data()];
                    case 2:
                        data = _a.sent();
                        return [4 /*yield*/, client.postStream(data, binaryWriteChunkImpulse.requestParameters(), '/data/sink/chunk')];
                    case 3:
                        chunkResponse = _a.sent();
                        if (this.config && this.config.onUploadProgress) {
                            progress = (100 * (index + 1)) / this.totalNumberOfChunks;
                            this.config.onUploadProgress(Math.ceil(progress));
                        }
                        chunkResponsesIds.push(chunkResponse.chunkId);
                        _a.label = 4;
                    case 4:
                        index++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/, chunkResponsesIds];
                }
            });
        });
    };
    DataUpload.CHUNK_SIZE = 1024 * 1024 * 5;
    return DataUpload;
}());
//# sourceMappingURL=DataRef.js.map